import * as types from '../ActionTypes/WorkoutsActionTypes';

export class WorkoutActionCreators {
    // get workout by id
    static getByIdRequest = workoutId => ({
        type: types.GET_WORKOUT_BY_ID_REQUEST,
        meta: { workoutId },
    });

    static getByIdSuccess = payload => ({
        type: types.GET_WORKOUT_BY_ID_SUCCESS,
        payload,
    });

    static getByIdFailed = payload => ({
        type: types.GET_WORKOUT_BY_ID_FAILED,
        payload,
    });

    // get random stock image for workout
    static getWorkoutStockImageRequest = (workoutType, callback) => ({
        type: types.GET_WORKOUT_STOCK_IMAGE_REQUEST,
        meta: { workoutType, callback },
    });

    static getWorkoutStockImageSuccess = payload => ({
        type: types.GET_WORKOUT_STOCK_IMAGE_SUCCESS,
        payload,
    });

    // upload workout image
    static uploadWorkoutImageRequest = (file, callback) => ({
        type: types.UPLOAD_WORKOUT_IMAGE_REQUEST,
        meta: { file, callback },
    });

    static uploadWorkoutImageSuccess = payload => ({
        type: types.UPLOAD_WORKOUT_IMAGE_SUCCESS,
        payload,
    });

    static uploadWorkoutImageFailed = payload => ({
        type: types.UPLOAD_WORKOUT_IMAGE_FAILED,
        payload,
    });

    // create workout
    static createWorkoutRequest = (workoutData, callback) => ({
        type: types.CREATE_WORKOUT_REQUEST,
        meta: { workoutData, callback },
    });

    static createWorkoutSuccess = () => ({
        type: types.CREATE_WORKOUT_SUCCESS,
    });

    static createWorkoutFailed = payload => ({
        type: types.CREATE_WORKOUT_FAILED,
        payload,
    });

    // get list of planned workouts
    static getPlannedWorkoutsRequest = (userId, offsetId, offsetDate) => ({
        type: types.GET_PLANNED_WORKOUTS_REQUEST,
        meta: { userId, offsetId, offsetDate },
    });

    static getPlannedWorkoutsSuccess = payload => ({
        type: types.GET_PLANNED_WORKOUTS_SUCCESS,
        payload,
    });

    static getPlannedWorkoutsFailed = payload => ({
        type: types.GET_PLANNED_WORKOUTS_FAILED,
        payload,
    });

    // get workouts of the day by date range
    static getWorkoutsOfTheDayByDateRangeRequest = (start, end) => ({
        type: types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_REQUEST,
        meta: { start, end },
    });

    static getWorkoutsOfTheDayByDateRangeSuccess = payload => ({
        type: types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_SUCCESS,
        payload,
    });

    static getWorkoutsOfTheDayByDateRangeFailed = payload => ({
        type: types.GET_WORKOUTS_OF_THE_DAY_BY_DATE_RANGE_FAILED,
        payload,
    });

    // add workout of the day
    static addWorkoutOfTheDayRequest = (workoutData, callback) => ({
        type: types.ADD_WORKOUT_OF_THE_DAY_REQUEST,
        meta: { workoutData, callback },
    });

    static addWorkoutOfTheDaySuccess = payload => ({
        type: types.ADD_WORKOUT_OF_THE_DAY_SUCCESS,
        payload,
    });

    static addWorkoutOfTheDayFailed = payload => ({
        type: types.ADD_WORKOUT_OF_THE_DAY_FAILED,
        payload,
    });

    // get week challenge
    static getWorkoutOfTheWeekRequest = mondayDate => ({
        type: types.GET_WORKOUT_OF_THE_WEEK_REQUEST,
        meta: { mondayDate },
    });

    static getWorkoutOfTheWeekSuccess = payload => ({
        type: types.GET_WORKOUT_OF_THE_WEEK_SUCCESS,
        payload,
    });

    static getWorkoutOfTheWeekFailed = payload => ({
        type: types.GET_WORKOUT_OF_THE_WEEK_FAILED,
        payload,
    });

    // add week challenge
    static addWorkoutOfTheWeekRequest = (workoutData, callback) => ({
        type: types.ADD_WORKOUT_OF_THE_WEEK_REQUEST,
        meta: { workoutData, callback },
    });

    static addWorkoutOfTheWeekSuccess = payload => ({
        type: types.ADD_WORKOUT_OF_THE_WEEK_SUCCESS,
        payload,
    });

    static addWorkoutOfTheWeekFailed = payload => ({
        type: types.ADD_WORKOUT_OF_THE_WEEK_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/WorkoutsActionCreators.js